import script from "./SerpResultsListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SerpResultsListItem.vue?vue&type=script&setup=true&lang=js"

import "./SerpResultsListItem.vue?vue&type=style&index=0&id=7040540e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7040540e"]])

export default __exports__